// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AddressAutocompleteController from "./address_autocomplete_controller";
application.register("address-autocomplete", AddressAutocompleteController);

import AddressFieldsController from "./address_fields_controller";
application.register("address-fields", AddressFieldsController);

import AutoScrollController from "./auto_scroll_controller";
application.register("auto-scroll", AutoScrollController);

import AutoSubmitController from "./auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import BarChartController from "./bar_chart_controller";
application.register("bar-chart", BarChartController);

import AutogrowTextAreaController from "./autogrow_text_area_controller";
application.register("autogrow-text-area", AutogrowTextAreaController);

import Bridge__LoadMessagesController from "./bridge/load_messages_controller";
application.register("bridge--load-messages", Bridge__LoadMessagesController);

import ChatwootController from "./chatwoot_controller";
application.register("chatwoot", ChatwootController);

import ClickableRowController from "./clickable_row_controller";
application.register("clickable-row", ClickableRowController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import CollectEventController from "./collect_event_controller";
application.register("collect-event", CollectEventController);

import CountdownController from "./countdown_controller";
application.register("countdown", CountdownController);

import DismissibleController from "./dismissible_controller";
application.register("dismissible", DismissibleController);

import Driver__PhotoUploadController from "./driver/photo_upload_controller";
application.register("driver--photo-upload", Driver__PhotoUploadController);

import ExpandableController from "./expandable_controller";
application.register("expandable", ExpandableController);

import FilesDropzoneController from "./files_dropzone_controller";
application.register("files-dropzone", FilesDropzoneController);

import FilesUploadController from "./files_upload_controller";
application.register("files-upload", FilesUploadController);

import FormSectionRefreshController from "./form_section_refresh_controller";
application.register("form-section-refresh", FormSectionRefreshController);

import LeafletMapController from "./leaflet_map_controller";
application.register("leaflet-map", LeafletMapController);

import ListInputsController from "./list_inputs_controller";
application.register("list-inputs", ListInputsController);

import PolygonController from "./polygon_controller";
application.register("polygon", PolygonController);

import TobiiGalleryController from "./tobii_gallery_controller";
application.register("tobii-gallery", TobiiGalleryController);

import PieChartController from "./pie_chart_controller";
application.register("pie-chart", PieChartController);

import RequireFieldsWhenVisibleController from "./require_fields_when_visible_controller";
application.register(
  "require-fields-when-visible",
  RequireFieldsWhenVisibleController,
);

import SignwellController from "./signwell_controller";
application.register("signwell", SignwellController);

import DocusealController from "./docuseal_controller";
application.register("docuseal", DocusealController);

import SlimSelectController from "./slim_select_controller";
application.register("slim-select", SlimSelectController);

import TimeCountdownController from "./time_countdown_controller";
application.register("time-countdown", TimeCountdownController);

import TimezoneFieldController from "./timezone_field_controller";
application.register("timezone-field", TimezoneFieldController);

import TurboModalController from "./turbo_modal_controller";
application.register("turbo-modal", TurboModalController);

import TooltipController from "./tooltip_controller";
application.register("tooltip", TooltipController);

import ToggleController from "./toggle_controller";
application.register("toggle", ToggleController);

import UnsavedChangesController from "./unsaved_changes_controller";
application.register("unsaved-changes", UnsavedChangesController);

import VisibilityController from "./visibility_controller";
application.register("visibility", VisibilityController);
